import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { StorageService } from '@fund-base/services/storage/storage.service';
import { AuthService } from '@fund-base/services/auth/auth.service';
import { authServiceInjectionToken } from '@fund-base/constants/auth/auth.constants';
import { canAccessVisitor, checkVisitor } from '@fund-base/utils/helpers/routing/routing.helpers';

@Injectable({
  providedIn: 'root',
})
export class VisitorsGuard implements CanActivate {
  constructor(
    private storageService: StorageService,
    @Inject(authServiceInjectionToken) private authService: AuthService,
    private store: Store,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return checkVisitor(this.store, this.authService, this.storageService).pipe(
      map(user => {
        // can access only if the user match the conditions
        const guardCondition = canAccessVisitor(user);
        if (!guardCondition) {
          this.router.navigate(['admin']);
        }
        return guardCondition;
      }),
    );
  }
}
